import { SATOSHI_POWER } from 'constants/power';

const roundBtcToSatoshi = (value: number): string | number => {
  return value?.toFixed(SATOSHI_POWER) || 0;
};

export default roundBtcToSatoshi;
